/**
 * Onboarding utilities
 *
 * Reads the onboarding_completed flag from organization.settings JSONB.
 * No DB migration needed — flag is stored in existing settings column.
 */

import type { ClientOrganization } from '@/lib/db/types';

/**
 * Check if onboarding has been completed for this organization.
 * Returns true if the flag exists and is truthy, false otherwise.
 */
export function isOnboardingCompleted(org: ClientOrganization | undefined | null): boolean {
  if (!org) return false;
  const settings = org.settings as Record<string, unknown> | null;
  return !!settings?.onboarding_completed;
}
